// extracted by mini-css-extract-plugin
export default {"text-color-light":"#707070","textColorLight":"#707070","color-mischka":"#e0e1e7","colorMischka":"#e0e1e7","button":"dGQaH a8cCT","content":"L24YN","closed":"BvurX","open":"M8T5y"};